const location = window.location.host;
const protocol = window.location.protocol;
export const ProfileItems = [
  // {
  //   name: "Meu mural",
  //   path: `#`,
  // },
  {
    name: "Meu perfil",
    path: `${process.env.REACT_APP_AMEI}/realms/externo/account?referrer=planejadora-sebrae&referrer_uri=${protocol}//${location}`,
  },
  {
    name: "Meu empreendimento",
    path: `${process.env.REACT_APP_CPE}/?voltar=${protocol}//${location}`,
  },
  {
    name: "Alterar senha",
    path: `${process.env.REACT_APP_AMEI}/realms/externo/account/password?referrer=planejadora-sebrae`,
  },
  {
    name: "Vincular redes sociais",
    path: `${process.env.REACT_APP_AMEI}/realms/externo/account/identity?referrer=planejadora-sebrae`,
  },
];

export const MenuItems = [
  {
    id: 1,
    name: "Início",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="currentColor"
      >
        <path
          d="M4.66705 0.827146C5.42625 0.148104 6.57387 0.148122 7.33307 0.827146L11.3331 4.333C11.7596 4.7145 12.0026 5.26077 12.0001 5.833V11.667C11.9999 12.7714 11.1045 13.667 10.0001 13.667H2.00006C0.895671 13.6669 0.000236139 12.7714 6.19519e-05 11.667V5.83984C-0.0044597 5.26522 0.238724 4.71608 0.667054 4.333L4.66705 0.827146ZM6.44049 1.83301C6.18895 1.61203 5.81228 1.61226 5.56061 1.83301L1.56061 5.333C1.41684 5.45931 1.33341 5.64164 1.33307 5.833V11.667C1.33324 12.035 1.63204 12.3329 2.00006 12.333H3.33307V9C3.33307 7.89558 4.22871 7.00024 5.33307 7H6.66705C7.77153 7.00011 8.66705 7.8955 8.66705 9V12.333H10.0001C10.3681 12.333 10.6669 12.035 10.6671 11.667V5.833C10.6667 5.64164 10.5843 5.45931 10.4405 5.333L6.44049 1.83301ZM5.33307 8.333C4.96509 8.33325 4.66706 8.63196 4.66705 9V12.333H7.33307V9C7.33307 8.63188 7.03515 8.33311 6.66705 8.333H5.33307Z"
          fill="currentColor"
        />
      </svg>
    ),
    path: "/inicio",
  },
  {
    id: 2,
    name: "Planejamentos",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 0.666626H12C13.1046 0.666626 14 1.56206 14 2.66663V13.3333C14 14.4379 13.1046 15.3333 12 15.3333H4C2.89543 15.3333 2 14.4379 2 13.3333V2.66663C2 1.56206 2.89543 0.666626 4 0.666626ZM5.33333 3.33329H10.6667C11.0349 3.33329 11.3333 3.63177 11.3333 3.99996V6.66663C11.3333 7.03482 11.0349 7.33329 10.6667 7.33329H5.33333C4.96514 7.33329 4.66667 7.03482 4.66667 6.66663V3.99996C4.66667 3.63177 4.96514 3.33329 5.33333 3.33329ZM5.58667 8.71996C5.62762 8.73327 5.66597 8.75357 5.7 8.77996L5.80667 8.85996C5.92849 8.98772 5.99754 9.15678 6 9.33329C5.9989 9.55502 5.88763 9.76168 5.70314 9.88467C5.51865 10.0077 5.28509 10.0309 5.08 9.94663C4.99921 9.91286 4.9248 9.86551 4.86 9.80663C4.73521 9.68081 4.66564 9.5105 4.66667 9.33329C4.66572 9.15217 4.73502 8.97773 4.86 8.84663L4.96 8.76663L5.08 8.70663L5.2 8.66663C5.28552 8.64672 5.37448 8.64672 5.46 8.66663C5.50498 8.67696 5.54784 8.69501 5.58667 8.71996ZM8.36685 11.4467C8.40499 11.4697 8.44073 11.4965 8.47352 11.5267C8.53421 11.5901 8.58179 11.6649 8.61352 11.7467C8.64768 11.8269 8.6658 11.9129 8.66685 12C8.66788 12.1772 8.59831 12.3476 8.47352 12.4734C8.40872 12.5323 8.33431 12.5796 8.25352 12.6134C8.1744 12.6507 8.08764 12.669 8.00019 12.6667C7.82298 12.6677 7.65267 12.5982 7.52685 12.4734C7.46818 12.4071 7.41884 12.333 7.38019 12.2534C7.34831 12.1728 7.33246 12.0867 7.33352 12C7.33127 11.9126 7.34953 11.8258 7.38685 11.7467C7.44747 11.5792 7.57937 11.4473 7.74685 11.3867C7.86615 11.3337 7.99913 11.3197 8.12685 11.3467C8.17101 11.3529 8.21382 11.3664 8.25352 11.3867C8.29448 11.4 8.33282 11.4203 8.36685 11.4467ZM5.80667 11.5266C5.74326 11.4659 5.6685 11.4184 5.58667 11.3866C5.46599 11.3307 5.33132 11.3121 5.2 11.3333L5.08 11.3733C5.03752 11.3879 4.99716 11.4081 4.96 11.4333C4.92508 11.4579 4.89168 11.4846 4.86 11.5133C4.79931 11.5767 4.75173 11.6515 4.72 11.7333C4.64868 11.8947 4.64868 12.0786 4.72 12.24C4.75376 12.3207 4.80111 12.3952 4.86 12.46C4.9836 12.5897 5.1542 12.6641 5.33333 12.6666C5.42078 12.6689 5.50755 12.6506 5.58667 12.6133C5.66746 12.5795 5.74187 12.5322 5.80667 12.4733C5.86555 12.4085 5.91291 12.3341 5.94667 12.2533C6.01798 12.0919 6.01798 11.908 5.94667 11.7466C5.91494 11.6648 5.86736 11.59 5.80667 11.5266ZM7.52667 8.85996C7.59007 8.79927 7.66483 8.75169 7.74667 8.71996C7.99493 8.61556 8.28163 8.6708 8.47333 8.85996C8.59516 8.98772 8.66421 9.15678 8.66667 9.33329C8.66769 9.5105 8.59812 9.68081 8.47333 9.80663C8.40853 9.86551 8.33412 9.91286 8.25333 9.94663C8.04824 10.0309 7.81468 10.0077 7.63019 9.88467C7.4457 9.76168 7.33444 9.55502 7.33333 9.33329C7.33579 9.15678 7.40484 8.98772 7.52667 8.85996ZM11.14 11.5266C11.0752 11.4677 11.0008 11.4204 10.92 11.3866C10.6717 11.2822 10.385 11.3375 10.1933 11.5266C10.1326 11.59 10.0851 11.6648 10.0533 11.7466C9.98202 11.908 9.98202 12.0919 10.0533 12.2533C10.0871 12.3341 10.1344 12.4085 10.1933 12.4733C10.3191 12.5981 10.4895 12.6677 10.6667 12.6666C10.7541 12.6689 10.8409 12.6506 10.92 12.6133C11.0008 12.5795 11.0752 12.5322 11.14 12.4733C11.3292 12.2816 11.3844 11.9949 11.28 11.7466C11.2483 11.6648 11.2007 11.59 11.14 11.5266ZM10 5.99996H6V4.66663H10V5.99996ZM12.6667 13.3333C12.6667 13.7015 12.3682 14 12 14H4C3.63181 14 3.33333 13.7015 3.33333 13.3333V2.66663C3.33333 2.29844 3.63181 1.99996 4 1.99996H12C12.3682 1.99996 12.6667 2.29844 12.6667 2.66663V13.3333ZM10.92 8.72026C10.961 8.73357 10.9993 8.75387 11.0333 8.78026L11.14 8.86026C11.2618 8.98801 11.3309 9.15708 11.3333 9.33359C11.3344 9.51079 11.2648 9.68111 11.14 9.80692C11.0752 9.86581 11.0008 9.91316 10.92 9.94692C10.7149 10.0312 10.4813 10.008 10.2969 9.88497C10.1124 9.76198 10.0011 9.55531 10 9.33359C10.0025 9.15708 10.0715 8.98801 10.1933 8.86026L10.2933 8.78026L10.4133 8.72026L10.5333 8.68026C10.6189 8.66035 10.7078 8.66035 10.7933 8.68026C10.8375 8.68644 10.8803 8.69996 10.92 8.72026Z"
          fill="currentColor"
        />
      </svg>
    ),
    path: "/planejamentos",
  },
  // {
  //   id: 3,
  //   name: "Navegação Guiada",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
  //       <path fillRule="evenodd" clipRule="evenodd" d="M7.33333 7.9333V11.3333C7.33333 11.7015 7.63181 12 8 12C8.36819 12 8.66667 11.7015 8.66667 11.3333V7.9333C10.3433 7.59106 11.4884 6.03484 11.3165 4.33229C11.1445 2.62974 9.71122 1.33398 8 1.33398C6.28878 1.33398 4.85554 2.62974 4.68355 4.33229C4.51155 6.03484 5.65669 7.59106 7.33333 7.9333ZM8 2.66664C9.10457 2.66664 10 3.56207 10 4.66664C10 5.77121 9.10457 6.66664 8 6.66664C6.89543 6.66664 6 5.77121 6 4.66664C6 3.56207 6.89543 2.66664 8 2.66664ZM10.1593 9.82539C10.3217 9.64413 10.5685 9.56329 10.8067 9.6133C12.8333 10.0533 14 10.9266 14 12C14 13.7533 10.98 14.6666 8 14.6666C5.02 14.6666 2 13.7533 2 12C2 10.9266 3.16667 10.0533 5.19333 9.58664C5.43151 9.53662 5.67828 9.61747 5.84068 9.79873C6.00309 9.97999 6.05646 10.2341 5.98068 10.4654C5.90491 10.6967 5.71151 10.87 5.47333 10.92C3.96 11.2466 3.33333 11.7866 3.33333 12C3.33333 12.3866 4.96667 13.3333 8 13.3333C11.0333 13.3333 12.6667 12.3866 12.6667 12C12.6667 11.7866 12.04 11.2466 10.5267 10.9466C10.2885 10.8966 10.0951 10.7233 10.0193 10.4921C9.94354 10.2608 9.99691 10.0067 10.1593 9.82539Z" fill="currentColor"/>
  //     </svg>
  //   ),
  //   path: "#",
  // },
  {
    id: 4,
    name: "Monitoramento",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99984 0.666626C3.94975 0.666626 0.666504 3.94987 0.666504 7.99996C0.666504 12.05 3.94975 15.3333 7.99984 15.3333C12.0499 15.3333 15.3332 12.05 15.3332 7.99996C15.3332 6.05504 14.5606 4.18978 13.1853 2.81451C11.81 1.43924 9.94476 0.666626 7.99984 0.666626ZM9.99984 5.99996C10.368 5.99996 10.6665 5.70148 10.6665 5.33329C10.6665 4.9651 10.368 4.66663 9.99984 4.66663H8.6665V3.99996C8.6665 3.63177 8.36803 3.33329 7.99984 3.33329C7.63165 3.33329 7.33317 3.63177 7.33317 3.99996V4.66663C6.2286 4.66663 5.33317 5.56206 5.33317 6.66663C5.33317 7.7712 6.2286 8.66663 7.33317 8.66663H8.6665C9.03469 8.66663 9.33317 8.9651 9.33317 9.33329C9.33317 9.70148 9.03469 9.99996 8.6665 9.99996H5.99984C5.63165 9.99996 5.33317 10.2984 5.33317 10.6666C5.33317 11.0348 5.63165 11.3333 5.99984 11.3333H7.33317V12C7.33317 12.3681 7.63165 12.6666 7.99984 12.6666C8.36803 12.6666 8.6665 12.3681 8.6665 12V11.3333C9.77107 11.3333 10.6665 10.4379 10.6665 9.33329C10.6665 8.22872 9.77107 7.33329 8.6665 7.33329H7.33317C6.96498 7.33329 6.6665 7.03482 6.6665 6.66663C6.6665 6.29844 6.96498 5.99996 7.33317 5.99996H9.99984ZM1.99984 7.99996C1.99984 11.3137 4.68613 14 7.99984 14C11.3135 14 13.9998 11.3137 13.9998 7.99996C13.9998 4.68625 11.3135 1.99996 7.99984 1.99996C4.68613 1.99996 1.99984 4.68625 1.99984 7.99996Z"
          fill="currentColor"
        />
      </svg>
    ),
    path: "/monitoramento",
  },
  {
    id: 5,
    name: "Consultoria",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3932 1.88001C10.1514 0.85873 8.51521 0.452127 6.93984 0.773345C4.82157 1.20122 3.17088 2.86508 2.75984 4.98668C2.46269 6.56148 2.88306 8.18678 3.90651 9.42001C4.37563 9.94939 4.64453 10.6264 4.66651 11.3333V13.3333C4.66651 14.4379 5.56194 15.3333 6.66651 15.3333H9.33318C10.4377 15.3333 11.3332 14.4379 11.3332 13.3333V11.46C11.3556 10.6795 11.6423 9.92963 12.1465 9.33335C13.9851 7.0589 13.6491 3.72801 11.3932 1.86668V1.88001ZM9.99984 13.3333C9.99984 13.7015 9.70137 14 9.33318 14H6.66651C6.29832 14 5.99984 13.7015 5.99984 13.3333V12.6667H9.99984V13.3333ZM9.99984 11.3333C10.0518 10.2947 10.4428 9.30174 11.1132 8.50668C11.6912 7.79966 12.0048 6.91325 11.9998 6.00001C12.0005 4.79729 11.4599 3.65811 10.5279 2.89798C9.59581 2.13785 8.37119 1.83746 7.19318 2.08001C5.81633 2.36507 4.69026 3.35208 4.22723 4.6797C3.76421 6.00731 4.03223 7.48054 4.93318 8.56001C5.60447 9.32985 5.98225 10.3121 5.99984 11.3333H7.33318V9.33335C7.33318 8.96516 7.63165 8.66668 7.99984 8.66668C8.36803 8.66668 8.66651 8.96516 8.66651 9.33335V11.3333H9.99984Z"
          fill="currentColor"
        />
      </svg>
    ),
    path: "/consultoria",
  },
  {
    id: 6,
    name: "Entenda a ferramenta",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6669 0.246707C12.1518 0.248694 12.6357 0.291063 13.1136 0.373374C13.4223 0.426305 13.6526 0.687087 13.6669 1.00004V9.00004C13.6698 9.19836 13.5842 9.38767 13.4334 9.51654C13.2827 9.6454 13.0823 9.70045 12.8869 9.66671C10.9469 9.35344 8.96271 9.83926 7.38689 11.0134L7.30689 11.06H7.23356C7.08422 11.1223 6.91622 11.1223 6.76689 11.06H6.69355L6.61355 11.0134C5.02676 9.86501 3.04357 9.40587 1.11356 9.74004C0.918104 9.77378 0.717779 9.71874 0.567004 9.58987C0.41623 9.461 0.330665 9.27169 0.333555 9.07337V1.07337C0.328785 0.745254 0.563505 0.462459 0.886889 0.406707C1.36476 0.324396 1.84865 0.282027 2.33356 0.28004C3.98466 0.268728 5.60432 0.731489 7.00022 1.61337C8.39254 0.719756 10.0125 0.245351 11.6669 0.246707ZM2.33356 8.24671C3.72723 8.24585 5.10014 8.5845 6.33356 9.23337V2.78004C5.14703 1.99583 3.75581 1.57847 2.33356 1.58004C2.11152 1.56724 1.88893 1.56724 1.66689 1.58004V8.24671H2.33356ZM12.3336 8.27337H11.6669C10.2732 8.27252 8.9003 8.61117 7.66689 9.26004V2.78004C8.85341 1.99583 10.2446 1.57847 11.6669 1.58004C11.8889 1.56724 12.1115 1.56724 12.3336 1.58004V8.27337ZM11.6669 10.9134C12.1518 10.9154 12.6357 10.9577 13.1136 11.04C13.2888 11.0679 13.4458 11.1644 13.5496 11.3083C13.6535 11.4522 13.6957 11.6316 13.6669 11.8067C13.5964 12.1671 13.2476 12.4026 12.8869 12.3334C10.9569 11.9992 8.97368 12.4583 7.38689 13.6067C7.15545 13.7715 6.845 13.7715 6.61355 13.6067C5.02676 12.4583 3.04357 11.9992 1.11356 12.3334C0.752869 12.4026 0.404092 12.1671 0.333555 11.8067C0.304742 11.6316 0.346939 11.4522 0.4508 11.3083C0.554661 11.1644 0.711613 11.0679 0.886889 11.04C1.36476 10.9577 1.84865 10.9154 2.33356 10.9134C3.98798 10.912 5.6079 11.3864 7.00022 12.28C8.39254 11.3864 10.0125 10.912 11.6669 10.9134Z"
          fill="currentColor"
        />
      </svg>
    ),
    path: "/como-utilizar",
  },
];
export const SubMenuItems = [
  {
    id: 1,
    name: "Termos de uso",
    path: "#",
  },
  {
    id: 2,
    name: "Política de privacidade",
    path: "#",
  },
  {
    id: 3,
    name: "Histórico de versões",
    path: "#",
  },
  {
    id: 4,
    name: "Sobre",
    path: "#",
  },
  {
    id: 5,
    name: "Ajuda",
    path: "#",
  },
];
